module.exports = __webpack_public_path__ + "ffee578d32fc9d9ed17eef972b649800.svg";